<template>
  <div class="app-content content devcontent ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
                <div class="row breadcrumbs-top">
                  <div class="col-md-12 content-header-left px-0">
                    <h3 class="content-header-title float-left mb-0" > Vehicle Routes  </h3>
                    
                    <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">live</a>
                                </li>
                                <li class="breadcrumb-item active">vehicle
                                </li>
                                <li class="breadcrumb-item active">routes
                                </li>
                                
                                
                                
                            </ol>
                        </div>
                  </div>
                </div>
            </div>
            
        </div>
      <div class="card content-body">
        <div class="card-header px-0  common_top_title_searchbgst_dock">
                    <div class="container-fluid " >
                        <div class="row row fc_my-05">
                            <div class="w-auto px-1 mobile-padding-0-2">
                                <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                    <div class="avatar-content">
                                        <em class="las la-route i_icon_st font-medium-5"></em>
                                    </div>
                                </div>
                                
                                <h4 class="card-title d-inline-flex ml-0 mb-0">Vehicle Routes Details</h4>
                            </div>
                        </div>    
                            
                    </div>
                </div>
          <section class="p-1 ">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                  <label class="form-label text-left w-100">Route Path</label>
                  <treeselect placeholder="Select Route Path" v-model="route" :options="routes" @input="handleRouteChange" />
              </div>
            </div>
            <div id="map"></div>
            <div ref="mapContainer" style="height:calc(100vh - 200px)"></div>
          </section>
      </div>
    </div>
  </div>
</template>
<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import VueElementLoading from 'vue-element-loading'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
import Treeselect from '@riophae/vue-treeselect'
export default {
  name: "MapRoutes",
  mixins: [common_methods, searchMasterNameList],
  data() {
    return {
      map: null,
      directionsService: null,
      directionsRenderer: null,
      locations2: [
        { lat: -31.56391, lng: 147.154312 },
        { lat: -33.718234, lng: 150.363181 },
        { lat: -33.727111, lng: 150.371124 },
        { lat: -33.848588, lng: 151.209834 },
        { lat: -33.851702, lng: 151.216968 },
        { lat: -34.671264, lng: 150.863657 },
        { lat: -35.304724, lng: 148.662905 },
        { lat: -36.817685, lng: 175.699196 },
        { lat: -36.828611, lng: 175.790222 },
        { lat: -37.75, lng: 145.116667 },
        { lat: -37.759859, lng: 145.128708 },
        { lat: -37.765015, lng: 145.133858 },
        { lat: -37.770104, lng: 145.143299 },
        { lat: -37.7737, lng: 145.145187 },
        { lat: -37.774785, lng: 145.137978 },
        { lat: -37.819616, lng: 144.968119 },
        { lat: -38.330766, lng: 144.695692 },
        { lat: -39.927193, lng: 175.053218 },
        { lat: -41.330162, lng: 174.865694 },
        { lat: -42.734358, lng: 147.439506 },
        { lat: -42.734358, lng: 147.501315 },
        { lat: -42.735258, lng: 147.438 },
        { lat: -43.999792, lng: 170.463352 },
      ],
      locations: [
        {
          "sector_name": "DELH",
          "lat": 28.4829357,
          "lng": 76.81108454,
          "vehicle_number_plate": "MH14HG8468"
        },
        {
          "sector_name": "AMCO",
          "lat": 30.20227746,
          "lng": 76.87500926,
          "vehicle_number_plate": "MH12LT3985"
        },
        {
          "sector_name": "JSPO",
          "lat": 22.83677573,
          "lng": 86.23336711,
          "vehicle_number_plate": "MH12LT3986"
        },
        {
          "sector_name": "BOMD",
          "lat": 19.32838749,
          "lng": 73.1034658,
          "vehicle_number_plate": "MH20BT3356"
        },
        {
          "sector_name": "BWD",
          "lat": 19.32861431,
          "lng": 73.10352915,
          "vehicle_number_plate": "MH14HG3655"
        },
        {
          "sector_name": "BGM",
          "lat": 15.89201189,
          "lng": 74.5409106,
          "vehicle_number_plate": "MH14GD1404"
        },
        {
          "sector_name": "HBL",
          "lat": 15.32081099,
          "lng": 75.10942451,
          "vehicle_number_plate": "MH43Y2893"
        },
        {
          "sector_name": "VPI",
          "lat": 20.3252149,
          "lng": 72.90557776,
          "vehicle_number_plate": "MH14KA5337"
        },
        {
          "sector_name": "BDQN",
          "lat": 22.398839,
          "lng": 73.137974,
          "vehicle_number_plate": "MH14HG3869"
        },
        {
          "sector_name": "AMDI",
          "lat": 22.92808983,
          "lng": 72.44836951,
          "vehicle_number_plate": "HR55W4756"
        },
        {
          "sector_name": "AMDO",
          "lat": 22.92808983,
          "lng": 72.44836951,
          "vehicle_number_plate": "HR55W4756"
        },
        {
          "sector_name": "CCUO",
          "lat": 22.76154221,
          "lng": 88.31523491,
          "vehicle_number_plate": "MH14KQ6037"
        },
        {
          "sector_name": "PATO",
          "lat": 25.5737419,
          "lng": 85.23991262,
          "vehicle_number_plate": "WB11F1584"
        },
        {
          "sector_name": "NAGO",
          "lat": 21.13866742,
          "lng": 78.90309435,
          "vehicle_number_plate": "OD11M0087"
        },
        {
          "sector_name": "RPR",
          "lat": 21.27997639,
          "lng": 81.60997476,
          "vehicle_number_plate": "NL01AG2486"
        },
        {
          "sector_name": "HYDO",
          "lat": 17.528655,
          "lng": 78.441097,
          "vehicle_number_plate": "WB11F1573"
        },
        {
          "sector_name": "BLRO",
          "lat": 12.75143254,
          "lng": 77.73542494,
          "vehicle_number_plate": "OD11L2687"
        },
        {
          "sector_name": "SLMO",
          "lat": 11.62699,
          "lng": 78.13533,
          "vehicle_number_plate": "RJ23GC5938"
        },
        {
          "sector_name": "MAAO",
          "lat": 13.04071433,
          "lng": 80.02772123,
          "vehicle_number_plate": "HR55AL5776"
        },
        {
          "sector_name": "PNQC",
          "lat": 18.44644856,
          "lng": 73.89023463,
          "vehicle_number_plate": "HR55AL5931"
        },
        {
          "sector_name": "PNQO",
          "lat": 18.44644856,
          "lng": 73.89023463,
          "vehicle_number_plate": "HR55AL5931"
        },
        {
          "sector_name": "SVN",
          "lat": 18.47426355,
          "lng": 73.80930238,
          "vehicle_number_plate": "HR55AL5976"
        },
        {
          "sector_name": "PNQE",
          "lat": 18.57847942,
          "lng": 73.98578634,
          "vehicle_number_plate": "HR55AM9958"
        },
        {
          "sector_name": "GOI",
          "lat": 15.36213232,
          "lng": 73.94698977,
          "vehicle_number_plate": "HR38AD0554"
        },
        {
          "sector_name": "ANR",
          "lat": 19.14585673,
          "lng": 74.70906402,
          "vehicle_number_plate": "HR38AD5454"
        },
        {
          "sector_name": "RNJ",
          "lat": 18.7730284,
          "lng": 74.2740854,
          "vehicle_number_plate": "HR55AM4642"
        },
        {
          "sector_name": "NSK",
          "lat": 19.9854691,
          "lng": 73.72609285,
          "vehicle_number_plate": "HR38AD5497"
        },
        {
          "sector_name": "SNN",
          "lat": 19.856815,
          "lng": 73.979488,
          "vehicle_number_plate": "HR55AL4079"
        },
        {
          "sector_name": "OZR",
          "lat": 20.07177963,
          "lng": 73.89373856,
          "vehicle_number_plate": "MH14KQ7944"
        },
        {
          "sector_name": "DUL",
          "lat": 20.83815244,
          "lng": 74.7571217,
          "vehicle_number_plate": "MH11CJ3299"
        },
        {
          "sector_name": "IXUW",
          "lat": 19.80110314,
          "lng": 75.23071114,
          "vehicle_number_plate": "MH11CH3299"
        },
        {
          "sector_name": "IXUE",
          "lat": 19.87778337,
          "lng": 75.37998454,
          "vehicle_number_plate": "MH11AL2524"
        },
        {
          "sector_name": "KRD",
          "lat": 17.248632,
          "lng": 74.177871,
          "vehicle_number_plate": "MH11CH2499"
        },
        {
          "sector_name": "KOP",
          "lat": 16.77121939,
          "lng": 74.27648328,
          "vehicle_number_plate": "MH46BF8842"
        },
        {
          "sector_name": "STR",
          "lat": 17.67768505,
          "lng": 74.0242399,
          "vehicle_number_plate": "MH14GU4077"
        },
        {
          "sector_name": "SWL",
          "lat": 18.16482411,
          "lng": 73.95068184,
          "vehicle_number_plate": "MH05DK4695"
        },
        {
          "sector_name": "BAR",
          "lat": 18.18475027,
          "lng": 74.60543403,
          "vehicle_number_plate": "MH11CH2775"
        },
        {
          "sector_name": "PHR",
          "lat": 18.4447963,
          "lng": 73.97279928,
          "vehicle_number_plate": "MH11CJ3499"
        },
        {
          "sector_name": "JJR",
          "lat": 18.2728,
          "lng": 74.165491,
          "vehicle_number_plate": "MH14LB9624"
        },
        {
          "sector_name": "PNQP",
          "lat": 18.54143142,
          "lng": 73.66814405,
          "vehicle_number_plate": "MH14CP5566"
        },
        {
          "sector_name": "PNQI",
          "lat": 18.66328,
          "lng": 73.790352,
          "vehicle_number_plate": "MH14GU4078"
        },
        {
          "sector_name": "SPR",
          "lat": 17.730193,
          "lng": 75.837023,
          "vehicle_number_plate": "MH14GD9426"
        },
        {
          "sector_name": "KKB",
          "lat": 18.39575617,
          "lng": 74.53104089,
          "vehicle_number_plate": "MH14HG9264"
        },
        {
          "sector_name": "PNQW",
          "lat": 18.58529858,
          "lng": 73.83276009,
          "vehicle_number_plate": "MH14HU9642"
        },
        {
          "sector_name": "PNQN",
          "lat": 18.74036563,
          "lng": 73.74435283,
          "vehicle_number_plate": "MH14GD9246"
        },
        {
          "sector_name": "JAIO",
          "lat": 26.87003759,
          "lng": 75.6908454,
          "vehicle_number_plate": "MH14BJ1910"
        },
        {
          "sector_name": "IDRO",
          "lat": 22.86541991,
          "lng": 75.96160904,
          "vehicle_number_plate": "MH14EM5051"
        },
        {
          "sector_name": "LKOD",
          "lat": 26.67192972,
          "lng": 80.85699734,
          "vehicle_number_plate": "MH12SX9264"
        },
        {
          "sector_name": "NDAO",
          "lat": 28.55796372,
          "lng": 77.46829135,
          "vehicle_number_plate": "MH12KP6269"
        },
        {
          "sector_name": "SMB",
          "lat": 21.50184855,
          "lng": 83.94405182,
          "vehicle_number_plate": "MH14KQ5743"
        }
      ],
      waypoints: [
        { lat: 16.77121939, lng: 78.90309435 },
        { lat: 21.13866742, lng: 78.90309435 },
        { lat: 18.58529858, lng: 73.83276009 },
        // Add more waypoints as needed
      ],
      routes: [],
      route: null,
      marker: null,
    };
  },
  components: {
    MarkerClusterer,
    Treeselect,
  },
  mounted() {
    this.initMap();
    this.getRoutes()
    if (!localStorage.getItem('reloaded')) {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
  },
  methods: {
    getRandomPositionOnRoute(polylineCoordinates) {
      let randomIndex = Math.floor(Math.random() * (polylineCoordinates.length - 1));
      var lat1 = polylineCoordinates[randomIndex].lat;
      var lng1 = polylineCoordinates[randomIndex].lng;
      var lat2 = polylineCoordinates[randomIndex + 1].lat;
      var lng2 = polylineCoordinates[randomIndex + 1].lng;

      var randomLat = lat1 + Math.random() * (lat2 - lat1);
      var randomLng = lng1 + Math.random() * (lng2 - lng1);

      return { lat: randomLat, lng: randomLng }
    },
    getRoutes() {
      this.searchNameMasterList('route_details', 'route_path', null, 'route_path')
        .then(result => {
            this.routes = result.data
            console.log(this.routes)
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    async initMap() {
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        zoom: 6,
        center: { lat: 21.13866742, lng: 78.90309435 },
        mapId: "DEMO_MAP_ID"
      });

      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer();
      this.directionsRenderer.setMap(this.map);

      this.calculateAndDisplayRoute();
    },
    calculateAndDisplayRoute() {
      const waypoints = this.waypoints.map(waypoint => ({
        location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
      }));

      const request = {
        origin: waypoints[0].location,
        destination: waypoints[waypoints.length - 1].location,
        waypoints: waypoints.slice(1, -1),
        travelMode: 'DRIVING',
      };

      this.directionsService.route(request, (response, status) => {
        if (status === 'OK') {
          this.directionsRenderer.setDirections(response);
          let position = this.getRandomPositionOnRoute(this.waypoints)
          this.addMarkenOnRoute(position)
        } else {
          this.sweetAlertSnackbar('Directions request failed due to ' + status, "error")
        }
      });
    },
    handleRouteChange(route) {
      let destinations = route.split("-")
      let waypoints = this.locations.filter(loc => destinations.includes(loc.sector_name))
      waypoints.sort((a, b) => {
        let indexA = destinations.indexOf(a.sector_name)
        let indexB = destinations.indexOf(b.sector_name)
        if(indexA > indexB) return 1
        if(indexA < indexB) return -1
        return 0
      })
      this.waypoints = waypoints
      let position = this.getRandomPositionOnRoute(this.waypoints)
      this.addMarkenOnRoute(position)
      this.calculateAndDisplayRoute()
    },
    async addMarkenOnRoute(position) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      const { Map, InfoWindow } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
        "marker",
      );
      const customIcon = {
        url: 'https://cdn-icons-png.flaticon.com/512/2344/2344094.png', // Provide the path to your custom icon image
        scaledSize: new google.maps.Size(25, 25), // Adjust the size as needed
      };
      const pinGlyph = new google.maps.marker.PinElement({
        glyph: "MH46BF8842",
        glyphColor: "white",
      });
      this.marker = new google.maps.Marker({
        position,
        icon: customIcon,
        map: this.map
      });
    },
    addMarkerAlongRoute() {

    }
  },
};
</script>

<style scoped>

#map {
    height: 100%;
}


html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
}
</style>